<div class="row">
    <div class="col-12">
        <app-card-v2 title="Général">
            <div class="row">
                <app-form-field [required]="true" label="Libellé">
                    <app-lov-value-select-filter [parentFormGroup]="formGroup"
                                                 lovListName="ACCOUNTING_MOVEMENT_LABEL"
                                                 parentFormControlName="labelValue"
                                                 style="width: 100%;">
                    </app-lov-value-select-filter>
                </app-form-field>

                <app-form-field [required]="true" label="Montant">
                    <app-amount-input [parentFormGroup]="formGroup" [required]="true"></app-amount-input>
                </app-form-field>
            </div>
        </app-card-v2>
    </div>
    <div class="col-12">
        <app-card-v2 title="Méthode de paiement">

            <app-loading *ngIf="paymentCardReaderSummaryFindAllService.loading$ | async" [showText]="false"></app-loading>
            <div class="row">
                <app-form-field size="12">
                    <div class="d-flex gap-5">
                        <mat-radio-group>
                            <mat-radio-button [checked]="selectedPaymentType === 'CARD_READER'" (click)="noCardReader ? undefined : changeSelectedPaymentType('CARD_READER')" [disabled]="noCardReader" *ngIf="enableCardReaderPayment">
                                Par lecteur de carte bancaire PodoPro
                            </mat-radio-button>
                            <mat-radio-button [checked]="selectedPaymentType === 'OTHER'" (click)="changeSelectedPaymentType('OTHER')">
                                Autre méthode de paiement
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </app-form-field>
            </div>
        </app-card-v2>
    </div>
    <div class="col-12">
        <app-card-v2 title="Paiement par lecteur de carte PodoPro" *ngIf="selectedPaymentType === 'CARD_READER'">
            <div class="row">
                <app-form-field label="Lecteur de carte" [required]="true">
                    <app-payment-card-reader-select-filter
                            [elements]="cardReadersElements"
                            [loading]="paymentCardReaderFindManyPaginatedService.loading$ | async"
                            [parentFormGroup]="formGroup" parentFormControlName="cardReaderId"></app-payment-card-reader-select-filter>
                </app-form-field>
                <app-form-field label="Compte cible" [required]="true">
                    <app-accounting-account-select-filter
                            typeValue="ONLINE"
                            [parentFormGroup]="formGroup"
                            parentFormControlName="targetAccountId"></app-accounting-account-select-filter>
                </app-form-field>
            </div>
        </app-card-v2>
    </div>
    <div class="col-12">
        <app-card-v2 title="Autre méthode de paiement" *ngIf="selectedPaymentType === 'OTHER'">
            <div class="row">
                <app-form-field [required]="true" label="Date" *ngIf="formGroup.get('date')">
                    <app-date-picker [parentFormGroup]="formGroup" parentFormControlName="date"></app-date-picker>
                </app-form-field>

                <app-form-field [required]="true" label="Moyen de paiement">
                    <app-payment-type-select-filter
                            [movementType]="movementType"
                            [parentFormGroup]="formGroup"
                            [paymentTypeValueToIgnore]="paymentTypeValueToIgnore"
                            parentFormControlName="paymentTypeValue" (_onSingleSelectionChange)="paymentTypeChanged($event)"></app-payment-type-select-filter>
                </app-form-field>

                <app-form-field *ngIf="sourceAccountIdFormControl" [required]="true" label="Du compte">
                    <app-accounting-account-select-filter
                            (_onSingleSelectionChange)="sourceAccountChanged($event)"
                            [parentFormGroup]="formGroup"
                            parentFormControlName="sourceAccountId"
                    ></app-accounting-account-select-filter>
                </app-form-field>

                <app-form-field *ngIf="targetAccountIdFormControl" [required]="true" label="Sur le compte">
                    <app-accounting-account-select-filter
                            [accountIdToIgnore]="sourceAccountIdFormControl?.value"
                            (_onSingleSelectionChange)="targetAccountChanged($event)"
                            [typeValue]="possibleTargetAccountType"
                            [parentFormGroup]="formGroup"
                            parentFormControlName="targetAccountId"></app-accounting-account-select-filter>
                </app-form-field>


                <ng-container *ngIf="formGroup.get('check')">
                    <app-form-field label="Numéro du chèque">
                        <app-input-text [parentFormGroup]="formGroup.get('check')" parentFormControlName="number"></app-input-text>
                    </app-form-field>
                    <app-form-field label="Emetteur du chèque">
                        <app-input-text [parentFormGroup]="formGroup.get('check')" parentFormControlName="from"></app-input-text>
                    </app-form-field>
                    <app-form-field label="Banque de l'émetteur">
                        <app-lov-value-select-filter lovListName="FINANCIAL_BANK" [parentFormGroup]="formGroup.get('check')" parentFormControlName="bankValue"></app-lov-value-select-filter>
                    </app-form-field>
                </ng-container>

                <app-form-field [sizeLg]="12" [sizeXl]="12" [size]="12" label="Commentaire">
                    <app-rich-text-editor [parentFormGroup]="formGroup" parentFormControlName="comment"></app-rich-text-editor>
                </app-form-field>
            </div>
        </app-card-v2>
    </div>
</div>
